/* eslint-disable react/no-unknown-property */
import React, { FunctionComponent } from 'react';
import * as styles from './Divider.style';

export interface DividerProps extends React.AriaAttributes {
  children?: string,
  padded?: boolean,
}

const Divider: FunctionComponent<DividerProps> = ({
  children,
  padded = true,
  ...rest
}) => (
  <div
    {...rest}
    css={styles.base}
    $padded={padded}
    $hasChildren={!!children}
  >
    {children && (
      children
    )}
  </div>
);

export default Divider;
